import { format, parseISO, formatDistanceToNow } from 'date-fns';

const usNumberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

const usMoneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatNumber(value, emptyValue = '-') {
  if (value === null || value === undefined || value === '') return emptyValue;

  const number = Number(value);
  return Number.isFinite(number) ? usNumberFormatter.format(number) : value;
}

export function formatMoney(value, emptyValue = '-') {
  if (value === null || value === undefined || value === '') return emptyValue;

  const number = Number(value);
  return Number.isFinite(number) ? usMoneyFormatter.format(number) : value;
}

export function formatPercent(value, emptyValue = '-') {
  if (value === null || value === undefined || value === '') return emptyValue;

  const number = Number(value);
  return Number.isFinite(number) ? `${usNumberFormatter.format(number)}%` : value;
}

export function formatUsDate(value, emptyValue = '-') {
  if (!value) return emptyValue;

  try {
    return format(parseISO(String(value).replace(' ', 'T')), 'MM/dd/yyyy');
  } catch (error) {
    return value;
  }
}

export function formatUsDateTime(value, emptyValue = '-') {
  if (!value) return emptyValue;

  try {
    return format(parseISO(String(value).replace(' ', 'T')), 'MM/dd/yyyy hh:mm a');
  } catch (error) {
    return value;
  }
}

function parseAndFormatDate(date, pattern) {
  if (!date) return 'Not set';

  try {
    return format(parseISO(date), pattern);
  } catch (error) {
    return date;
  }
}

export default {
  install(Vue) {
    Vue.filter('capitalize', text => {
      return text
        .split(' ')
        .map(item => `${item.charAt(0).toUpperCase() + item.slice(1)}`)
        .join(' ');
    });
    Vue.filter('formatDate', date => {
      return parseAndFormatDate(date, 'do MMM yyyy');
    });
    Vue.filter('shortFormatDate', date => {
      return parseAndFormatDate(date, 'MM/dd');
    });
    // formats time until a given date (e.g., "1h 30m" or a full date if it's in the past)
    Vue.filter('timeUntil', date => {
      const target = new Date(date);
      const now = new Date();

      const diff = target - now;

      if (diff <= 0) {
        return parseAndFormatDate(date, "MMM do yyyy 'at' HH:mm");
      }

      const totalMinutes = Math.floor(diff / 1000 / 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours}h : ${minutes}m`;
    });
    //formats time relative to the current moment (e.g., "1m ago", "5m ago", or a full date if it's older)
    Vue.filter('formatRelativeTime', date => {
      if (!date) return 'Not set';

      const parsedDate = parseISO(date);
      const diffInMinutes = Math.abs((new Date() - parsedDate) / (1000 * 60));

      if (diffInMinutes < 60 * 24) {
        return formatDistanceToNow(parsedDate, { addSuffix: true });
      } else {
        return format(parsedDate, "MM/dd/yyyy hh:mm a");
      }
    });
    Vue.filter('formatDateTime', date => {
      return parseAndFormatDate(date, "MMM do yyyy 'at' HH:mm");
    });
    Vue.filter('formatMoney', value => {
      return formatMoney(value);
    });
    Vue.filter('formatNumber', value => {
      return formatNumber(value);
    });
    Vue.filter('formatPercent', value => {
      return formatPercent(value);
    });
    Vue.filter('formatUsDate', value => {
      return formatUsDate(value);
    });
    Vue.filter('formatUsDateTime', value => {
      return formatUsDateTime(value);
    });
    Vue.filter('formatPhone', value => {
      if (!value) return value;

      let m = value.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (m) {
        return (m[1] ? '+1 ' : '') + '(' + m[2] + ') ' + m[3] + '-' + m[4];
      }
      return value;
    });
  },
};
